import { useMemo } from 'react';
import { pick } from 'lodash/fp';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';

import {
  LabelValueDetails,
  LabelValue,
  TimeSignal,
  LabelValueSource
} from 'graphql/types';
import { useIsSmartSuggestionSettingEnabled } from './useIsSmartSuggestionSettingEnabled';
import { determineLabelAcceptedBy } from './utils';

export const picker = pick(['idValue', 'numericValue', 'stringValue']);
export const useCollatedTimesheetLabels = (
  timeSignal: TimeSignal,
  labels: TimesheetLabel[]
): TimesheetLabel[] => {
  const labelValues = timeSignal?.labelValues as LabelValueDetails[];
  const isSmartSuggestionEnabled = useIsSmartSuggestionSettingEnabled();
  return useMemo(
    () =>
      (labels || []).map((label: TimesheetLabel) => {
        const labelValue = labelValues?.find((lv) => lv.label.id == label.id);
        const returnValue = {
          ...label,
          value: labelValue?.value ? picker(labelValue.value) : null
        };
        if (isSmartSuggestionEnabled) {
          returnValue.valueSource = labelValue?.valueSource;
          returnValue.suggestedValues = labelValue?.suggestedValues
            ? (labelValue?.suggestedValues.map(picker) as [LabelValue])
            : undefined;
          returnValue.suggestionMetadata =
            labelValue?.suggestionMetadata || undefined;
        }
        returnValue.acceptedBy = determineLabelAcceptedBy(
          returnValue.valueSource ?? LabelValueSource.User,
          labelValue?.acceptedBy,
          isSmartSuggestionEnabled
        );
        return returnValue;
      }),
    [labels, labelValues, isSmartSuggestionEnabled]
  );
};

export default useCollatedTimesheetLabels;
